// src/services/orderService.js
import axiosService from 'services/axiosService';
import { API } from 'constants/Api';

// MAIN SERVICE ***************************************************************
// *****************************************************************************

const orderService = {};

// get a single (server-decorated) order by id
orderService.getOrderById = async orderId => {
  if (!orderId) return null;
  const baseUrl = API.APPMULTI_ORDER.DETAIL || API.APPMULTI_ORDER.URL;
  const url = baseUrl.replace(':_id', orderId);
  const [doc] = await axiosService.get({ url, returnAsObject: true });
  return doc;
};

// fire-and-forget order email (backend handler is Phase 2 — never block on it)
orderService.sendEmail = async (orderId, type = 'created') => {
  if (!orderId) return null;
  return axiosService.post({
    url: API.APPMULTI_ORDER.SEND_EMAIL,
    data: { _id: orderId, action: type },
  });
};

// EXPORT *********************************************************************
// *****************************************************************************

export default orderService;
